import { useState } from "react";
import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { offNoticeModal } from "redux/reducers/noticeModalReducer";
import { Container, ImgBox, TextBox, Wrap, Wrapper } from "./style";
const NoticeModal = ({ data }) => {
  const [isActive, setIsActive] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  const setCookie = useCookies()[1];
  const dispatch = useDispatch();
  const checkHandler = () => {
    setIsChecked(!isChecked);
  };
  const closeHandler = () => {
    if (isChecked) {
      const now = new Date();
      const expires = new Date(now.setDate(now.getDate() + 1));
      setCookie(`sketch_htm${data.id}`, true, { path: "/", expires });
    }
    setIsActive(false);
    dispatch(offNoticeModal());
  };

  const imgClickHandler = () => {
    if (data.url) window.open(data.url);
  };
  return (
    <>
      {isActive && (
        <Wrap>
          <Wrapper>
            <div onClick={imgClickHandler} alt="urlToClickImg">
              <img loading="lazy" src={data.img_path} alt="NoticeImg" />
            </div>
            <Container>
              <TextBox onClick={checkHandler}>
                <ImgBox loading="lazy" bg={isChecked}>
                  {isChecked && <img loading="lazy" src="/assets/img/Modal_1.svg" alt="CheckImg" />}
                </ImgBox>
                <span>오늘 하루 보지 않기</span>
              </TextBox>
              <span onClick={closeHandler}>닫기</span>
            </Container>
          </Wrapper>
        </Wrap>
      )}
    </>
  );
};

export default NoticeModal;
